import styles from "./styles.module.css";
import { PageValue } from "../../../contexts/page";
import { useContext } from "react";
import Layer from "./layer";
export default function Layers({ open }) {
  const tree = useContext(PageValue);
  if (!tree) {
    return null;
  }
  return (
    <div
      style={{
        overflowY: "scroll",
        boxSizing: "border-box",
        boxSizing: "border-box",
        position: "absolute",
        top: 80,
        left: 10,
        right: 10,
      }}
      className={open ? styles.open : styles.close}
    >
      <div>
        <Layer
          path={[]}
          level={1}
          accept={["component", "overlay"]}
          block={tree}
          noHide
        />
      </div>
    </div>
  );
}
